import { useContext, useMemo } from "react";

import { medicarePartBStrategies, medicarePartDStrategies } from "../constants/constants";
import { MemberEligibilityContext } from "../context";

export const useIsDiscountUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);

  const isDiscountUser = useMemo(() => {
    const bin = memberEligibility?.plan?.bin_number;
    const pcn = memberEligibility?.plan?.processor_control_number;

    return bin === "610852" && pcn === "CAPLRX";
  }, [memberEligibility]);

  return { isDiscountUser };
};

export const useIsMedicareUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);

  const isMedicareUser = useMemo(() => {
    const medicareIndicator = memberEligibility?.member?.medicare_indicator;
    return medicareIndicator === "Y";
  }, [memberEligibility]);

  const isPartD = useMemo(() => {
    const coverageStrategyType = memberEligibility?.plan_benefit?.coverage_strategy_type;
    return medicarePartDStrategies.includes(coverageStrategyType);
  }, [memberEligibility]);

  const isPartB = useMemo(() => {
    const coverageStrategyType = memberEligibility?.plan_benefit?.coverage_strategy_type;
    return medicarePartBStrategies.includes(coverageStrategyType);
  }, [memberEligibility]);

  return { isMedicareUser, isPartD, isPartB };
};

export const useIsUnifiedUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const disallowedClientIds = ["CAPLRX7", "JD43", "JD413"];

  const isUnifiedUser = useMemo(() => {
    return (
      !disallowedClientIds.includes(memberEligibility?.plan?.client_id)
      && !!memberEligibility?.member_version_ddb?.medical_group_id
      && !!memberEligibility?.medical_group
      && !!memberEligibility?.medical_plan_benefit
    );
  }, [memberEligibility]);

  return { isUnifiedUser };
};

export const useIsDentalUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);

  // TODO: Check memberEligibility.dental_group and memberEligibility.dental_plan_benefit when made available
  const allowedClientIds = ["CAPLRX7", "JD413", "KETARX1", "JDMED"];
  const isDentalUser = allowedClientIds.includes(memberEligibility?.plan?.client_id);

  return { isDentalUser };
};

export const useIsVisionUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);

  // TODO: Check memberEligibility.vision_group and memberEligibility.vision_plan_benefit when made available
  const allowedClientIds = ["CAPLRX7", "JD413", "KETARX1", "JDMED"];
  const isVisionUser = allowedClientIds.includes(memberEligibility?.plan?.client_id);

  return { isVisionUser };
};

export const useIsPharmacyUser = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);

  // TODO: Do something in the database to designate non-pharmacy users instead of hardcoding client ids here
  const disallowedClientIds = ["JD413"];
  const isNonPharmacyUser = disallowedClientIds.includes(memberEligibility?.plan?.client_id);

  if (isNonPharmacyUser) {
    // Using a guard clause here to make it clear this is currently a weird edge case
    return { isPharmacyUser: false };
  }

  return { isPharmacyUser: true };
};

export const useShowUnifiedCard = () => {
  const { isUnifiedUser } = useIsUnifiedUser();
  const { memberEligibility } = useContext(MemberEligibilityContext);

  const allowedClientIds = ["JD155", "KETARX1", "JDMED"];
  const showUnifiedCard = isUnifiedUser && allowedClientIds.includes(memberEligibility?.plan?.client_id);

  return { showUnifiedCard };
};
